import {createEntitySlice} from '../../../utils/createEntitySlice';
import {VisitDocument} from '../../../types/visitDocument';
import {VisitDocumentThunks} from './visitDocumentThunks';

export interface VisitDocumentState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  visitDocuments?: any;
  visitDocument?: any;
  pagy?: any;
  isEditing?: boolean;
  activeTab?: string;
}

const initialState: VisitDocumentState = {
  status: 'idle',
  error: null,
  visitDocuments: [],
  visitDocument: {},
  pagy: {},
  isEditing: false,
  activeTab: 'Documents',
};

const visitDocumentSlice = createEntitySlice<VisitDocument>({
  name: 'visitDocument',
  initialState,
  thunks: VisitDocumentThunks,
  entityKey: 'visitDocument',
  entitiesKey: 'visitDocuments',
  reducers: {},
});

export const {
  setEntity: setVisitDocument,
  setIsEditing,
  setActiveTab,
} = visitDocumentSlice.actions;
export {initialState as visitDocumentInitialState};
export default visitDocumentSlice.reducer;
